import React, { useEffect, useState } from "react";
import CrearPeriodos from "../../../components/admin/periodos/periodos";
import ListadoPeriodos from "../../../components/admin/periodos/listadoPeriodos";

const initialState = {
  nombre: "",
  fecha_inicio: "",
  fecha_fin: "",
};

const Periodos = () => {
  const [updateList, setUpdateList] = useState(false);
  const [type, setType] = useState("save");
  const [state, setState] = useState(initialState);
  useEffect(() => {
    return () => {};
  }, []);

  const updateListFn = () => {
    setUpdateList(!updateList);
  };

  const resetState = () => {
    setState(initialState);
  };
  return (
    <div className="h-100 px-3 bgfondo2 d-flex justify-content-start flex-column ">
      <CrearPeriodos
        updateListFn={updateListFn}
        state={state}
        setState={setState}
        type={type}
        setType={setType}
        resetState={resetState}
      />
      <ListadoPeriodos
        updateList={updateList}
        updateListFn={updateListFn}
        setState={setState}
        setType={setType}
      />
    </div>
  );
};

export default Periodos;
